export const WHATSAPP_URL =
  "https://wa.me/918136800133?text=Hi%20Movementor%2C%20I%27d%20like%20to%20talk%20to%20a%20study-abroad%20mentor.";

export const NEXT_ASSESSMENT_URL = "https://movementor.in/";

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Journey", href: "#journey" },
  { label: "Destinations", href: "#destinations" },
  { label: "Why Us", href: "#why" },
  { label: "Team", href: "#team" },
  { label: "NEXT", href: "#next" },
  { label: "Contact", href: "#contact" },
];
